<div>
<p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
</div>